import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./AdminDashboard.module.scss";
import { createBlogPost } from "../../../../ApiLayer/admin";
import ConfirmPopup from "../../../../Components/ConfirmPopupComponent/ConfirmPopup";
import UserManagerTab from "./Tabs/UserManagerTab";
import TabContainer from "./Tabs/TabContainer";
const AdminDashboard = () => {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    navigate("/admin/signIn");
  };




  return (
    <div className={styles.container}>
      <ConfirmPopup
        isOpen={showLogoutConfirm}
        onClose={() => setShowLogoutConfirm(false)}
        onConfirm={handleLogout}
        title="Logout"
        confirmText="Logout"
        message="Are you sure you want to logout?"
      />
      <div className={styles.header}>
        <h1>Admin Dashboard</h1>
        <button
          className={styles.logoutButton}
          onClick={() => setShowLogoutConfirm(true)}
        >
          Logout
        </button>
      </div>

    <TabContainer />
    </div>
  );
};

export default AdminDashboard;
